import Store from 'store/store';

const fire = (action, cat, label) => {
	if (!window.firePowsterCustomEvent) return;
	window.firePowsterCustomEvent(action, cat, label);
};

Store.on('TRACK_AUTH_SUCCESS', () => {
	fire('amazon-prime-auth-success', 'membership', '-');
});

Store.on('TRACK_GET_PRIME', () => {
	fire('get-prime', 'membership', '-');
});

Store.on('ADD_TO_WALLET', ( { client }) => {
	fire('add-to-wallet', 'tickets', `${client}`);
});

Store.on('TRACK_PRIME_REGION_SELECT', (region) => {
	fire('select-region', 'login', region);
});

Store.on('TRACK_PRIME_LOGIN_CLICK', () => {
	fire('amazon-login', 'login', 'click');
});

Store.on('TRACK_NAV_LINK_CLICK', (content) => {
	if (content?.match(/Amazon Prime/)) {
		Store.emit('TRACK_GET_PRIME');
	}
});

Store.on('TRACK_MANAGE_TICKETS', () => {
	fire('manage-tickets', 'tickets', '-');
});

Store.on('TRACK_BOOK_TICKETS', ({ theaterName, numTickets }) => {
	fire('book-tickets', 'tickets', `${theaterName}_${numTickets} Ticket(s)`);
});

Store.on('TRACK_CANCEL_TICKETS', ({ theaterName, numTickets }) => {
	fire('cancel-tickets', 'tickets', `${theaterName}_${numTickets} Ticket(s)`);
});

Store.on('TRACK_DOWNLOAD_TICKET', ({ theaterName, numTickets }) => {
	fire('download-tickets', 'tickets', `${theaterName}_${numTickets} Ticket(s)`);
});

Store.on('TRACK_TOUT_WATCHLIST_CLICK', ( { title }) => {
	fire('tout-click-horizontal', 'tout', `${title} - Add to Watchlist`);
});

Store.on('TRACK_SIGNUP_FORM_SUBMIT', ( { label }) => {
	fire('signup-form-submit', 'signup', `${label}`);
});

Store.on('TRACK_EARLY_ACCESS_CODE_SOLD_OUT_WATCHLIST', () => {
	fire('early-access-sold-out-add-to-watchlist', 'add-to-watchlist', '-');
});